// using for portal CITY
export const permissionConstants = {
  GET_LOGGED_REQUEST: 'GET_LOGGED_REQUEST',
  GET_LOGGED_SUCCESS: 'GET_LOGGED_SUCCESS',
  GET_LOGGED_FAILURE: 'GET_LOGGED_FAILURE',

  GET_PERMISSION_REQUEST: 'GET_PERMISSION_REQUEST',
  GET_PERMISSION_SUCCESS: 'GET_PERMISSION_SUCCESS',
  GET_PERMISSION_FAILURE: 'GET_PERMISSION_FAILURE',

  ADD_PERMISSION_REQUEST: 'ADD_PERMISSION_REQUEST',
  ADD_PERMISSION_SUCCESS: 'ADD_PERMISSION_SUCCESS',
  ADD_PERMISSION_FAILURE: 'ADD_PERMISSION_FAILURE',

  GET_PERMISSIONS_REQUEST: 'GET_PERMISSIONS_REQUEST',
  GET_PERMISSIONS_SUCCESS: 'GET_PERMISSIONS_SUCCESS',
  GET_PERMISSIONS_FAILURE: 'GET_PERMISSIONS_FAILURE',

  UPDATE_PERMISSION_REQUEST: 'UPDATE_PERMISSION_REQUEST',
  UPDATE_PERMISSION_SUCCESS: 'UPDATE_PERMISSION_SUCCESS',
  UPDATE_PERMISSION_FAILURE: 'UPDATE_PERMISSION_FAILURE',

  DELETE_PERMISSION_REQUEST: 'DELETE_PERMISSION_REQUEST',
  DELETE_PERMISSION_SUCCESS: 'DELETE_PERMISSION_SUCCESS',
  DELETE_PERMISSION_FAILURE: 'DELETE_PERMISSION_FAILURE',

};
